<template>
  <v-app id="inspire">
    <my-side-bar :drawer="drawer"></my-side-bar>
    <my-header @changeDrawer="updateDrawer" :drawer="drawer" ></my-header>
    
    <v-main>
      <v-container class="" fluid>
        <v-row class="px-3">
          <v-card>
            <v-card-title cols="12" >
              Gestione Utenza
              <v-spacer></v-spacer>
            </v-card-title>
           <div>
             <div class="text-center" v-if="isLoading">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
            <v-form ref="form">
              <v-container>
                <v-expansion-panels
                  multiple
                  focusable
                  v-model="panel"
                >
                  <v-expansion-panel>
                    <!--<v-expansion-panel-header>Dati Utenza</v-expansion-panel-header>-->
                    <v-expansion-panel-header v-slot="{ open }">
                      <v-row no-gutters>
                        <v-col cols="4">
                          Dati Utenza
                        </v-col>
                        <v-col
                          cols="8"
                          class="text--secondary"
                        >
                          <v-fade-transition leave-absolute>
                            <span v-if="open" class="info-panel">Gestisci i dati di accesso al portale</span>
                            <v-row
                              v-else
                              no-gutters
                              style="width: 100%"
                            >
                              <v-col cols="6">
                                Username: {{ userData.username || 'Not set' }}
                              </v-col>
                              <v-col cols="6">
                                Role: {{ userData.role.role_name || 'Not set' }}
                              </v-col>
                            </v-row>
                          </v-fade-transition>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row cols="12">
                        <v-col cols="12" sm="6" md="3" >
                          <v-text-field label="Username" v-model="userData.username" :rules="[rules.required]" :readonly="http_verb==='put'"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" v-if="http_verb==='put'">
                          <v-text-field label="Vecchia Password" v-model="userData.oldPassword" ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" >
                          <v-text-field label="Nuova Password" v-model="userData.newPassword" :rules="[checkPassword]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" >
                          <v-text-field label="Ripeti Password" v-model="userData.confirmPassword" :rules="[(userData.newPassword === userData.confirmPassword) || 'Password must match']"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row cols="12">
                        <!--<v-col cols="12" sm="6" md="3" >
                          <v-text-field label="Nome" v-model="userData.firstname" :rules="[rules.required,rules.counter]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" >
                          <v-text-field label="Cognome" v-model="userData.lastname" :rules="[rules.required,rules.counter]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" >
                          <v-text-field label="E-mail" v-model="userData.email" :rules="[rules.required, rules.email]" ></v-text-field>
                        </v-col>-->
                        <v-col cols="12" sm="6" md="3">
                          <v-combobox
                            v-model="userData.role"
                            :items="roles"
                            label="Ruolo"
                            @change="changeRole()"
                            item-text="role_name"
                            item-value="id"
                          ></v-combobox>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <!-- <v-expansion-panel-header>Dati Contatto</v-expansion-panel-header> -->
                    <v-expansion-panel-header v-slot="{ open }">
                      <v-row no-gutters>
                        <v-col cols="4">
                          Dati Contatto
                        </v-col>
                        <v-col
                          cols="8"
                          class="text--secondary"
                        >
                          <v-fade-transition leave-absolute>
                            <span v-if="open" class="info-panel">Gestisci i dati del contatto</span>
                            <v-row
                              v-else
                              no-gutters
                              style="width: 100%"
                            >
                              <v-col cols="6">
                                Nome: {{ userData.firstname || 'Not set' }}
                              </v-col>
                              <v-col cols="6">
                                Cognome: {{ userData.lastname || 'Not set' }}
                              </v-col>
                            </v-row>
                          </v-fade-transition>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row cols="12">
                        <v-col cols="12" sm="6" md="3" >
                          <v-text-field label="Nome" v-model="userData.firstname" :rules="[rules.required,rules.counter]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" >
                          <v-text-field label="Cognome" v-model="userData.lastname" :rules="[rules.required,rules.counter]"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3" >
                          <v-text-field label="E-mail" v-model="userData.email" :rules="[rules.required, rules.email]" ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field label="Cellulare" v-model="contactData.cell" ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field label="Provincia" v-model="contactData.country" ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field label="Comune" v-model="contactData.city"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field label="Cap" v-model="contactData.code"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field label="Indirizzo" v-model="contactData.address"></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field label="Civico" v-model="contactData.address_number"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field label="Nazione" v-model="contactData.nation"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                          <v-text-field label="Codice Fiscale" v-model="contactData.fiscal_code"></v-text-field>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>Dati Privacy</v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        Qui ci saranno i check della privacy ....se servono ancora....
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel v-if="userLoggedPermissions.manage_user_role_permissions">
                    <!--<v-expansion-panel-header>Permessi <span class="txt-info">(read only)</span></v-expansion-panel-header>-->
                    <v-expansion-panel-header>
                      <template v-slot:default="{ open }">
                        <v-row no-gutters>
                          <v-col cols="4">
                            Permessi
                          </v-col>
                          <v-col
                            cols="8"
                            class="text--secondary"
                          >
                            <v-fade-transition leave-absolute>
                              <span
                                v-if="open"
                                key="0"
                                class="info-panel"
                              >
                                Sola lettura
                              </span>
                            </v-fade-transition>
                          </v-col>
                        </v-row>
                      </template>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row v-if="userLoggedPermissions.manage_user_role_permissions">
                        <v-col cols="12" sm="12" md="12" >
                          <ul>
                            <li v-for="p in objPermissions" :key="p.id">
                              <v-row>
                              <v-col cols="12" sm="12" md="3">
                                <v-checkbox
                                  :label="p.name"
                                  color="primary"
                                  :value="p.active"
                                  hide-details
                                  v-model="p.active"
                                  readonly
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" sm="12" md="3">
                                <v-checkbox
                                  label="Write"
                                  color="primary"
                                  :value="p.write"
                                  hide-details
                                  v-model="p.write"
                                  readonly
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" sm="12" md="3">
                                <v-checkbox
                                  label="Delete"
                                  color="primary"
                                  :value="p.delete"
                                  hide-details
                                  v-model="p.delete"
                                  readonly
                                ></v-checkbox>
                              </v-col>
                              </v-row>
                            </li>
                          </ul>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <!--
                <v-row v-if="userLoggedPermissions.manage_user_role_permissions">
                  <label>Permessi <span class="txt-info">(read only)</span></label>
                  <v-col cols="12" sm="12" md="12" >
                    <ul>
                      <li v-for="p in objPermissions" :key="p.id">
                        <v-row>
                        <v-col cols="12" sm="12" md="3">
                          <v-checkbox
                            :label="p.name"
                            color="primary"
                            :value="p.active"
                            hide-details
                            v-model="p.active"
                            readonly
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="12" md="3">
                          <v-checkbox
                            label="Write"
                            color="primary"
                            :value="p.write"
                            hide-details
                            v-model="p.write"
                            readonly
                          ></v-checkbox>
                        </v-col>
                        <v-col cols="12" sm="12" md="3">
                          <v-checkbox
                            label="Delete"
                            color="primary"
                            :value="p.delete"
                            hide-details
                            v-model="p.delete"
                            readonly
                          ></v-checkbox>
                        </v-col>
                        </v-row>
                      </li>
                    </ul>
                  </v-col>
                </v-row>
                -->
                <!-- <v-row>
                  <v-btn color="success" class="mr-4" @click="saveUserData">
                    Salva
                  </v-btn>
                </v-row> -->
              </v-container>
            </v-form>
          </div>
          
          </v-card>
        </v-row>
      </v-container>
      <v-speed-dial
            v-model=fab
            :top=top
            :bottom=bottom
            :right=right
            :left=left
            :direction=direction
            :open-on-hover=hover
            :transition=transition
          >
            <template v-slot:activator>
              <v-btn v-model="fab" color="blue darken-2" dark fab>
                <v-icon v-if="fab">
                  mdi-close
                </v-icon>
                <v-icon v-else>
                  mdi-account-circle
                </v-icon>
              </v-btn>
            </template>
            <v-tooltip left v-if="userLoggedPermissions.manage_users !== undefined && userLoggedPermissions.manage_users.write ===1">
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab dark small v-bind="attrs" v-on="on" color="green" @click="saveUserData">
                  <v-icon>mdi-content-save-edit-outline</v-icon>
                </v-btn>
              </template>
              <span>Salva Utente</span>
            </v-tooltip>
            <v-tooltip left v-if="http_verb==='put' && userLoggedPermissions.manage_users.delete ===1">
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab dark small v-bind="attrs" v-on="on" color="red" @click="deleteUser">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Cancella Utente</span>
            </v-tooltip>
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab dark small v-bind="attrs" v-on="on" color="indigo" @click="backToUsers" >
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
              </template>
              <span>Vai alla lista</span>
            </v-tooltip>
          </v-speed-dial>
    </v-main>
  </v-app>
</template>

<script>
  import SideBar from '../components/SideBar.vue';
  import Header from '../components/Header.vue';
  
  //import { VueGoodTable } from 'vue-good-table';
  // import the styles
  //import 'vue-good-table/dist/vue-good-table.css'
  import { usersUrl, rolesUrl, permissionsUrl, getHeader } from '../config.js';

  import router from '../router';

  import { store } from '../store';

  const axios = require('axios');

  export default {
    props: {
      source: String,
    },
    components:{
      'my-side-bar':SideBar,
      'my-header':Header
    },
    data: () => ({
      direction: 'top',
      fab: false,
      fling: true,
      hover: false,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: 'slide-y-reverse-transition',
      dialog: false,
      drawer: true,
      isLoading: true,
      userId: null,
      userData: {
        firstname: '',
        lastname: '',
        email: '',
        role: '',
        username: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      contactData: {
        id: '',
        cell: '',
        country: '',
        city: '',
        code: '',
        address: '',
        address_number: '',
        nation: '',
        fiscal_code: ''
      },
      roles:[],
      permissions: [],
      objPermissions: {},
      rules: {
          required: value => !!value || 'Required.',
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
          password: value => {
            const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
            if(!value){
              if(this.http_verb == "post"){
                return false || 'Required.';
              }else{
                return true;
              }  
            }else{
              return pattern.test(value) || 'Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character'
            }
          }
      },
      http_verb: '',
      userLogged : {},
      userLoggedPermissions : {},
      panel: [0,1] 
    }),
    watch: {
    },
    async mounted () {
      console.log('userId', this.$route.params.userId);
      this.userId = this.$route.params.userId;

      this.userLogged = store.state.user;
      this.userLoggedPermissions = store.state.permissions;

      if(this.userLoggedPermissions.manage_users === undefined){
        this.$fire({
          title: "Accesso Negato",
          text: "Non si hanno i privilegi per accedere a questa pagina",
          type: "error",
          timer: 5000
        }).then(r => {
          console.log(r.value);
        });

        router.push({name:'Home'});

      }

      if(this.userLoggedPermissions.manage_user_role_permissions){
        await this.getPermissions();
      }
      
      await this.getRoles();
      
      if(this.userId){
        this.getFromServer();
        this.http_verb = 'put';
      }else{
        this.userData = {
          firstname: '',
          lastname: '',
          email: '',
          role: '',
          username: '',
          oldPassword: '',
          newPassword: '',
          confirmPassword: '',
          modified: ''
        };
        this.contactData = {
          id : '',
          cell: '',
          country: '',
          city: '',
          code: '',
          address: '',
          address_number: '',
          nation: '',
          fiscal_code: ''
        };
        this.http_verb = 'post';
        this.isLoading = false;
      }
      
    },
    methods: {
      checkPassword(value){
            const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
            if(!value){
              if(this.http_verb == "post"){
                return false || 'Required.';
              }else{
                return true;
              }  
            }else{
              return pattern.test(value) || 'Minimum eight characters, at least one uppercase letter, one lowercase letter, one number and one special character'
            }
      },
      updateDrawer(value){
        this.drawer = value;
      },
      getFromServer(){

        var header = getHeader();

        axios.get(usersUrl + '/' + this.userId, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                // handle success
                console.log(response.data);

                if(response.data && response.data.user){
                  this.userData.firstname = response.data.user.nome;
                  this.userData.lastname = response.data.user.cognome;
                  this.userData.email = response.data.user.email;
                  this.userData.username = response.data.user.username;
                  this.userData.role = {id: response.data.user.role_id, role_name:response.data.user.role};
                  this.userData.modified = response.data.user.modified;

                  this.userData.oldPassword = '';
                  this.userData.newPassword = '';
                  this.userData.confirmPassword = '';
                }

                if(response.data && response.data.contacts){
                  this.contactData.id = response.data.contacts.id;
                  this.contactData.cell = response.data.contacts.cellulare;
                  this.contactData.country = response.data.contacts.provincia;
                  this.contactData.city = response.data.contacts.comune;
                  this.contactData.code = response.data.contacts.cap;
                  this.contactData.address = response.data.contacts.indirizzo;
                  this.contactData.address_number = response.data.contacts.num_civico;
                  this.contactData.nation = response.data.contacts.nazione;
                  this.contactData.fiscal_cod = response.data.contacts.cf;
                }
                //console.log(this.objPermissions);

                var objPermissions = this.objPermissions;

                if(response.data && response.data.permissions){
                  response.data.permissions.forEach(function(item){
                    if(item.name){
                      objPermissions[item.name].active = 1;
                      objPermissions[item.name].write = item.write;
                      objPermissions[item.name].delete = item.delete;
                    }
                  });
                }
                
                this.objPermissions = objPermissions;
                this.isLoading = false;

            })
            .catch(function (error) {
                // handle error
                alert(error);
                this.isLoading = false;
            });

      },
      async getRoles(){
        var header = getHeader();

        return await axios.get(rolesUrl, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                // handle success
                //console.log(response.data);
                var listRoles = [];

                if(response.data && response.data.rows){

                  response.data.rows.forEach(function(item){
                    listRoles.push({id: item.id, role_name:item.role_name});
                  });

                }

                this.roles = listRoles;
                console.log('listRoles', listRoles);

                return true;
            })
            .catch(function (error) {
                // handle error
                alert(error)
            });
      },
      async getPermissions(){
        var header = getHeader();

        var res = await axios.get(permissionsUrl, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                // handle success
                //console.log(response.data);
                var objPermissions = {};

                if(response.data && response.data.rows){

                  response.data.rows.forEach(function(item){
                    
                      objPermissions[item.permission_name] = {
                        'id' : item.id,
                        'name' : item.permission_name,
                        'active' : 0,
                        'write' : 0,
                        'delete' : 0
                      };

                  });

                  

                }

                this.objPermissions = objPermissions;
                console.log('objPermissions', objPermissions);

                return true;
            })
            .catch(function (error) {
                // handle error
                alert(error)
            });

          return res;
      },
      saveUserData(){

        this.isLoading = true;

        var valid = this.$refs.form.validate();

        if(valid){

          console.log(this.objPermissions);

          var header = getHeader();

          var objToSave = {
            user_id : this.userId,
            userData : this.userData,
            userContact : this.contactData
          };

          if (this.http_verb === 'put'){

            axios.put(usersUrl + '/' + this.userId, objToSave, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                console.log(response);

                if(response.data.result === "OK"){
                  
                  this.getFromServer();

                  this.$fire({
                    title: "Dati salvati",
                    text: "Salvataggio avvenuto con successo",
                    type: "success",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                }else{

                  var text = response.data.msg != '' ? response.data.msg : "Dati inseriti non validi, si prega di verificare.";
                  this.$fire({
                    title: "Errore nei dati!",
                    text: text,
                    type: "error",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                }
                this.isLoading = false;
                
            })
            .catch(function (error) {
                // handle error
                alert(error);
                this.isLoading = false;
            });

          }else{
            
            axios.post(usersUrl, objToSave, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                console.log(response);

                if(response.data.result === "OK"){
                  
                  this.$fire({
                    title: "Dati salvati",
                    text: "Salvataggio avvenuto con successo",
                    type: "success",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                  this.backToUsers();

                }else{

                  var text = response.data.msg != '' ? response.data.msg : "Dati inseriti non validi, si prega di verificare.";
                  this.$fire({
                    title: "Errore nei dati!",
                    text: text,
                    type: "error",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                }
                this.isLoading = false;
                
            })
            .catch(function (error) {
                // handle error
                alert(error);
                this.isLoading = false;
            });

          }

        }else{
          this.$fire({
            title: "Errore nei dati!",
            text: "Dati inseriti non validi, si prega di verificare.",
            type: "error",
            timer: 5000
          }).then(r => {
            console.log(r.value);
          });

          this.isLoading = false;

        }

        

      },
      changeRole(){

        console.log(this.userData.role);

        var header = getHeader();

        this.isLoading = true;
        
        if( this.userData.role !== null){

          axios.get(permissionsUrl + '/' + this.userData.role.id, {
            headers: {
              'Accept' : header.Accept,
              'Authorization' : header.Authorization
            }
          })
          .then((response) => {
              // handle success
              //console.log(response.data);
              
              if(response.data && response.data.permissions){

                console.log('new permission', response.data.permissions);
                this.showPermission(response.data.permissions);

              }

              

          })
          .catch(function (error) {
              // handle error
              alert(error);
              
          });

        }

        this.isLoading = false;

      },
      showPermission(newPermission){

        console.log('new permission', newPermission);
        console.log('old permission', this.objPermissions);

        var objPermissions = this.objPermissions;

        for (const [key] of Object.entries(objPermissions)) {
          objPermissions[key].active = 0;
          objPermissions[key].write = 0;
          objPermissions[key].delete = 0;
        }

        console.log('reset objPermission' , objPermissions);

        if(newPermission.length > 0){
          newPermission.forEach(function(item){
            console.log('itero per', item);
            objPermissions[item.permission_name].active = 1;
            objPermissions[item.permission_name].write = item.write;
            objPermissions[item.permission_name].delete = item.delete;
          });
        }

        this.objPermissions = objPermissions;

      },
      backToUsers(){
        router.push({name:'Users'});
      },
      deleteUser(){
        
        this.$fire({
          title: 'Sei sicuro?',
          text: "L'operazione non sarà reversibile!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Si, cancella!'
        }).then(r => {
            if(r.value){
              
              this.isLoading = true;

              var header = getHeader();

              axios.delete(usersUrl + '/' + this.userId, {
              headers: {
                'Accept' : header.Accept,
                'Authorization' : header.Authorization
              }
            })
            .then((response) => {
                console.log(response);

                if(response.data.affected == "1"){
                  
                  this.$fire({
                    title: "Cancellato!",
                    text: "Utente cancellato con successo",
                    type: "success",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                  this.backToUsers();

                }else{

                  var text = response.data.msg != '' ? response.data.msg : "E' avvenuto un errore, si prega di riprovare.";
                  this.$fire({
                    title: "Errore!",
                    text: text,
                    type: "error",
                    timer: 5000
                  }).then(r => {
                    console.log(r.value);
                  });

                }
                this.isLoading = false;
                
            })
            .catch(function (error) {
                // handle error
                alert(error);
                this.isLoading = false;
            });

          }
        });

      }
    },
    computed: {
      user(){
        return this.$store.state.user;
      }
    }
  }
</script>

<style scoped>
.v-card{
  width:100%;
}
span.txt-info{
  color:grey;
  font-style: italic;
  font-size: 10px;
}
/* This is for documentation purposes and will not be needed in your application */
   .v-speed-dial {
    position: absolute;
  }

   .v-btn--floating {
    position: relative;
  }

  span.info-panel{
    font-style: italic;
  }
</style>
